import { render, staticRenderFns } from "./allVacantShiftsListing.vue?vue&type=template&id=80c28c52&"
import script from "./allVacantShiftsListing.vue?vue&type=script&lang=js&"
export * from "./allVacantShiftsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports